import React from 'react';

import { FaceIcon } from '@vlabs/icons';
import { TypeCard, TypeIcon } from '@vlabs/monokit/shared/ui/type-card';
import { useModal } from '@vlabs/uikit';

import { CreatedHandlerModal } from './CreatedHandlerModal';
import { DefineAttributesForm } from './DefineAttributesForm';
import type { DefineAttributesFormValues } from './DefineAttributesForm';
import { defineAttributes } from './handlerFactories.js';
import { useCreateHandlerTranslation } from './i18n';
import { useCreateHandlerWithResult } from './useCreateHandlerWithResult';

function DefineAttributesCard(): React.JSX.Element {
  const { t } = useCreateHandlerTranslation();
  const formModal = useModal({ size: 'small' });
  const {
    closeResult, createHandler, createdHandler,
  } = useCreateHandlerWithResult();

  const onSubmit = async (values: DefineAttributesFormValues) => {
    await createHandler(
      values,
      defineAttributes as (handlerValues: DefineAttributesFormValues) => unknown,
    );
    formModal.close();
  };

  return (
    <React.Fragment>
      {formModal.wrap(<DefineAttributesForm onSubmit={onSubmit} />)}
      <CreatedHandlerModal
        handlerId={createdHandler?.handlerId}
        handlerName={createdHandler?.handlerName}
        onClose={closeResult}
      />
      <TypeCard
        data-testid="handler.defineAttributes"
        description={t('cards.attributes.description')}
        icon={(
          <TypeIcon variant="pink">
            <FaceIcon />
          </TypeIcon>
        )}
        onClick={formModal.open}
        title={t('cards.attributes.title')}
      />
    </React.Fragment>
  );
}

export { DefineAttributesCard };
